import { useGetFeatureFlagsQuery } from 'src/services/dashboard-api';

export default function useIsDeflectionInsightsEnabled() {
  const { data: featureFlagsData } = useGetFeatureFlagsQuery();
  const { feature_flags: featureFlags = [] } = featureFlagsData ?? {};

  return featureFlags.includes('deflection_insights_ui');
}
